// Mock factories for bridge / culvert / structure-related codes.
// Each builder returns { message_key, data: { global_variables, result: [...] } }
// where each result row carries an error_id + the fields its renderer reads.

const baseGlobals = () => ({
    project_title: 'Mock Project',
    project_file: 'mock.prj',
    plan_title: 'Plan 01',
    units: 'English (ft)',
});

export const structureMocks = {
    'ST 07': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'ST 07',
                    data: [
                        {cross_section: 'RS 12345', type: 'Bridge', number: 1},
                        {cross_section: 'RS 12200', type: 'Culvert', number: 2},
                        {cross_section: 'RS 12050', type: 'Inline Weir', number: null},
                    ],
                },
            ],
        },
    }),

    'ST 09': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'ST 09',
                    data: [
                        {
                            cross_section: 'RS 12345',
                            barrel_name: 'Barrel #1',
                            direction: 'US',
                            left_bank: 100.0,
                            station: 95.5,
                            right_bank: 110.0,
                            off: 4.5,
                        },
                        {
                            cross_section: 'RS 12345',
                            barrel_name: 'Barrel #1',
                            direction: 'DS',
                            left_bank: 101.2,
                            station: 112.0,
                            right_bank: 111.5,
                            off: 0.5,
                        },
                        {
                            cross_section: 'RS 12200',
                            barrel_name: 'Barrel #2',
                            direction: 'US',
                            left_bank: 80.0,
                            station: 90.0,
                            right_bank: 95.0,
                            off: 5.0,
                        },
                    ],
                },
            ],
        },
    }),

    'OP 01': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'OP 01',
                    data: [
                        {cross_section: 'RS 12345', profile: '100yr'},
                        {cross_section: 'RS 12345', profile: '500yr'},
                        {cross_section: 'RS 12200', profile: '100yr'},
                    ],
                },
            ],
        },
    }),

    'ST 05': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'ST 05',
                    data: [
                        {type: 'Bridge', cross_section: 'RS 12345', sections: [2, 3]},
                        {type: 'Culvert', cross_section: 'RS 12200', sections: [4]},
                    ],
                },
            ],
        },
    }),

    'ST 10': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'ST 10',
                    data: [
                        {
                            cross_section: 'RS 12345',
                            culvert_name: 'Culvert #1',
                            section_2_dist: 12.5,
                            section_2_error: true,
                            section_3_dist: 4.2,
                            section_3_error: true,
                            ds_min: 5,
                            ds_max: 10,
                            us_min: 5,
                            us_max: 10,
                        },
                        {
                            cross_section: 'RS 12200',
                            culvert_name: 'Culvert #2',
                            section_2_dist: 7.0,
                            section_2_error: false,
                            section_3_dist: 8.5,
                            section_3_error: false,
                            ds_min: 5,
                            ds_max: 10,
                            us_min: 5,
                            us_max: 10,
                        },
                    ],
                },
            ],
        },
    }),

    'OP 02': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'OP 02',
                    data: [
                        {cross_section: 'RS 12345', profile: '100yr', side: 'L'},
                        {cross_section: 'RS 12345', profile: '500yr', side: 'R'},
                        {cross_section: 'RS 12200', profile: '100yr', side: 'L'},
                    ],
                },
            ],
        },
    }),

    'RT 03': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'RT 03',
                    footnotes: [1, 2],
                    data: [
                        {
                            cross_section: 'RS 12345',
                            type: 'Bridge',
                            footnote: 1,
                            chn_indexes: [1, 2],
                            err_overbank_indexes: [0],
                            mann_table: [
                                [0, 0.08],
                                [10, 0.04],
                                [25, 0.045],
                                [40, 0.06],
                            ],
                        },
                        {
                            cross_section: 'RS 12200',
                            type: 'Culvert',
                            footnote: null,
                            chn_indexes: [1],
                            err_overbank_indexes: [],
                            mann_table: [
                                [0, 0.07],
                                [12, 0.035],
                                [30, 0.05],
                            ],
                        },
                    ],
                },
            ],
        },
    }),

    'RT 04': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'RT 04',
                    footnotes: [1],
                    data: [
                        {
                            cross_section: 'RS 12345',
                            type: 'Bridge',
                            footnote: 1,
                            chn_indexes: [1, 2],
                            chn_error: true,
                            chn_error_indexes: [1],
                            err_overbank_indexes: [0],
                            mann_table: [
                                [0, 0.15],
                                [10, 0.005],
                                [25, 0.045],
                                [40, 0.06],
                            ],
                        },
                        {
                            cross_section: 'RS 12200',
                            type: 'Culvert',
                            footnote: null,
                            chn_indexes: [1],
                            chn_error: false,
                            chn_error_indexes: [],
                            err_overbank_indexes: [2],
                            mann_table: [
                                [0, 0.04],
                                [12, 0.035],
                                [30, 0.5],
                            ],
                        },
                    ],
                },
            ],
        },
    }),

    'RT-05': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'RT-05',
                    footnotes: [2],
                    data: [
                        {
                            cross_section: 'RS 12345',
                            left_bank: 25.0,
                            left_station: 24.5,
                            right_bank: 75.0,
                            right_station: 75.0,
                        },
                        {
                            cross_section: 'RS 12200',
                            left_bank: 30.0,
                            left_station: 30.0,
                            right_bank: 80.0,
                            right_station: 79.5,
                        },
                    ],
                },
            ],
        },
    }),

    'XY 11': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'XY 11',
                    data: [
                        {cross_section: 'RS 12345', channel: 150.0, length: 142.5, diff: 7.5},
                        {cross_section: 'RS 12200', channel: 200.0, length: 185.0, diff: 15.0},
                    ],
                },
            ],
        },
    }),

    'XY 13': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'XY 13',
                    data: [
                        {cross_section: 'RS 12345'},
                        {cross_section: 'RS 12200'},
                        {cross_section: 'RS 12050'},
                    ],
                },
            ],
        },
    }),

    'FL 04': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'FL 04',
                    profiles: ['100yr', '500yr'],
                    data: [
                        {cross_section: 'RS 12345', profile: '100yr', is_increase: true, val: 1200},
                        {cross_section: 'RS 12345', profile: '500yr', is_increase: false, val: 1800},
                        {cross_section: 'RS 12200', profile: '100yr', is_increase: false, val: 1150},
                        {cross_section: 'RS 12200', profile: '500yr', is_increase: true, val: 1850},
                    ],
                },
            ],
        },
    }),

    'FW 00a': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'FW 00a',
                    data: [
                        {cross_section: 'RS 12345'},
                        {cross_section: 'RS 12200'},
                        {cross_section: 'RS 12050'},
                    ],
                },
            ],
        },
    }),

    'FW 00b': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'FW 00b',
                    data: [
                        {cross_section: 'RS 11900'},
                        {cross_section: 'RS 11750'},
                    ],
                },
            ],
        },
    }),

    'XS 05': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'XS 05',
                    max_dsrl: 35.5,
                    e_times: 4,
                    data: [
                        {
                            cross_section: 'RS 12345',
                            highlight: true,
                            dsrl: 160.4,
                            headloss: 1.25,
                            conv_ratio: 0.55,
                            vel_head: 0.6,
                        },
                        {
                            cross_section: 'RS 12200',
                            highlight: false,
                            dsrl: 140.0,
                            headloss: 0.95,
                            conv_ratio: 1.45,
                            vel_head: 0.7,
                        },
                    ],
                },
            ],
        },
    }),

    'XS 05a': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'XS 05a',
                    max_dsrl: 35.5,
                    e_times: 4,
                    data: [
                        {cross_section: 'RS 12345', profile: '100yr'},
                        {cross_section: 'RS 12200', profile: '100yr'},
                        {cross_section: 'RS 12050', profile: '500yr'},
                    ],
                },
            ],
        },
    }),

    'XS 05b': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'XS 05b',
                    data: [
                        {cross_section: 'RS 12345', profile: '100yr'},
                        {cross_section: 'RS 12200', profile: '100yr'},
                        {cross_section: 'RS 12050', profile: '500yr'},
                    ],
                },
            ],
        },
    }),

    'XS 05c': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'XS 05c',
                    data: [
                        {cross_section: 'RS 12345', profile: '100yr'},
                        {cross_section: 'RS 12200', profile: '500yr'},
                    ],
                },
            ],
        },
    }),

    'XS 05d': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: baseGlobals(),
            result: [
                {
                    error_id: 'XS 05d',
                    data: [
                        {cross_section: 'RS 12345', profile: '100yr'},
                        {cross_section: 'RS 12200', profile: '500yr'},
                    ],
                },
            ],
        },
    }),
};
